module.exports = __webpack_public_path__ + "files/789276921b9546c92d2d6aa728559a4e.png";